import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/ops/')({
  component: OpsPage,
})

// The boards are consolidated behind a single Cognito-gated host. Cognito's
// hosted login sends X-Frame-Options: DENY, so this must be a full-page
// navigation (never an iframe). The old two-card chooser lived here; the
// wrapper at nest-ops now IS the ops <-> ghostmode toggle view.
const NEST_OPS_URL = 'https://nest-ops.thephenom.app'

function OpsPage() {
  useEffect(() => {
    window.location.replace(NEST_OPS_URL)
  }, [])

  return (
    <div className='flex flex-col h-full w-full items-center justify-center gap-2 p-8 text-center'>
      <p className='text-lg font-medium'>Redirecting to N.E.S.T. Operations…</p>
      <a href={NEST_OPS_URL} className='text-sm text-muted-foreground underline'>
        {NEST_OPS_URL}
      </a>
    </div>
  )
}
